import { actionCreators } from './actionCreators';
import { reducer } from './reducer';

const eventsStore = {
    actionCreators,
    reducer,
};

export default eventsStore;
